import React from 'react';

import { IChat } from '@sv-support-sdk/shared-types/src/common/chats';
import List from '@sv-support-sdk/ui-components/src/components/Lists/List';

import ChatRate from '../components/Chat/ChatRate';

import { $l } from '../locales';
import { ITableColumn } from '../types/commonTypes';

export const chatListColumn: ITableColumn<IChat>[] = [
  {
    name: $l('TICKETS.TICKET_LIST_DATE'),
    key: 'dateAndTime',
    cell: ({ closedAt }) => (
      <List align="center" direction="row" isWrapped>
        <div>{closedAt}</div>
      </List>
    ),
    textColor: 'grey',
  },
  { name: $l('TICKETS.TICKET_LIST_ID'), key: 'id', cell: ({ id }) => id },
  {
    name: $l('TICKETS.TICKET_LIST_SUBJECT'),
    key: 'subject',
    cell: ({ firstMessage }) => firstMessage?.message || '',
    width: '50%',
  },
  {
    name: $l('TICKETS.TICKET_LIST_STATUS'),
    key: 'status',
    cell: ({ score, rate }) => <ChatRate rate={score || rate} />,
  },
];
